module.exports = __webpack_public_path__ + "img/trolley-icon-white.5827a2aa.png";